// extracted by mini-css-extract-plugin
module.exports = {"progress":"Fetching_progress__2SeW1"};